/// <amd-module name="Feed/Legacy/Protocols/Components/PackageStats" />
import * as React from "react";

import { IVssIconProps, VssIcon, VssIconType } from "VSSUI/VssIcon";

import { Feed, PackageMetrics, PackageVersionMetrics } from "Feed/Common/Contracts/Feed";
import * as CommonResources from "Feed/Common/Resources";
import { MetricType } from "Feed/Common/Types/MetricType";
import { ILoadingContainerProps, LoadingContainer } from "Feed/Legacy/Components/LoadingContainer";
import { IMetricProps, Metrics } from "Feed/Legacy/Components/Metric";
import { isPublicFeed } from "Feed/Legacy/Helpers/ProjectHelper";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import * as PackageDetailsResources from "Feed/PackageDetails/Resources";

export interface IPackageStatsProps {
    packageVersionMetrics: PackageVersionMetrics;
    packageMetrics: PackageMetrics;
    isMetricsLoading: boolean;
    feed: Feed;
}

export const PackageStats: React.StatelessComponent<IPackageStatsProps> = props => {
    const versionDownloadProps: IMetricProps = {
        metrics: props.packageVersionMetrics,
        metricType: MetricType.DownloadCount,
        className: "version-downloads",
        resourceStrings: {
            singular: PackageDetailsResources.MetricsVersionDownload,
            plural: PackageDetailsResources.MetricsVersionDownloads
        }
    };
    const totalDownloadProps: IMetricProps = {
        metrics: props.packageMetrics,
        metricType: MetricType.DownloadCount,
        className: "total-downloads",
        resourceStrings: {
            singular: PackageDetailsResources.MetricsTotalDownload,
            plural: PackageDetailsResources.MetricsTotalDownloads
        }
    };

    const isFeedPublic = isPublicFeed(props.feed);
    let versionUserProps: IMetricProps;
    let totalUserProps: IMetricProps;

    if (!isFeedPublic) {
        versionUserProps = {
            metrics: props.packageVersionMetrics,
            metricType: MetricType.UniqueUsers,
            className: "version-users",
            resourceStrings: {
                singular: PackageDetailsResources.MetricsVersionUser,
                plural: PackageDetailsResources.MetricsVersionUsers
            }
        };

        totalUserProps = {
            metrics: props.packageMetrics,
            metricType: MetricType.UniqueUsers,
            className: "total-users",
            resourceStrings: {
                singular: PackageDetailsResources.MetricsTotalUser,
                plural: PackageDetailsResources.MetricsTotalUsers
            }
        };
    }

    const loadingContainerProps: ILoadingContainerProps = {
        isLoading: props.isMetricsLoading,
        cssClass: "package-attribute-item"
    };
    const iconProps: IVssIconProps = {
        iconType: VssIconType.fabric,
        iconName: "AlertSolid"
    };

    return (
        <div className="package-stats">
            <PackageAttribute title={CommonResources.PackageAttributeTitle_Stats}>
                <LoadingContainer {...loadingContainerProps}>
                    {props.packageMetrics == null || props.packageVersionMetrics == null ? (
                        <div className="metrics-error">
                            {<VssIcon {...iconProps} className="metric-error-icon" />}
                            {PackageDetailsResources.Error_ErrorLoadingMetrics}
                        </div>
                    ) : (
                        <div>
                            <Metrics {...versionDownloadProps} />
                            <Metrics {...totalDownloadProps} />
                            {!isFeedPublic && <Metrics {...versionUserProps} />}
                            {!isFeedPublic && <Metrics {...totalUserProps} />}
                        </div>
                    )}
                </LoadingContainer>
            </PackageAttribute>
        </div>
    );
};
